import React from "react";

import { IonBadge } from "@ionic/react";

import "./status.css";

interface StatusProps {
  type: number;
}

type statusOptions = {
  [key: string]: string;
};

const StatusTypesText: statusOptions = {
  1: "Aguardando Confirmação",
  2: "Cancelada",
  3: "Confirmada",
  4: "Finalizada"
};

const StatusTypesColor: statusOptions = {
  1: "warning",
  2: "danger",
  3: "success",
  4: "primary"
};

const Status: React.FC<StatusProps> = ({ type }) => {
  return (
    <IonBadge className="status-badged" color={StatusTypesColor[type]}>
      {StatusTypesText[type]}
    </IonBadge>
  );
};

export default Status;
